import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '@utils/utils';

class InitialStateProps {
    config = null;
    isMobile = false;
    isMenuMobileSelected = false;
}

const initialState: InitialStateProps = new InitialStateProps();

const reducer = (state = initialState, action) : InitialStateProps => {
    switch(action.type){
        case actionTypes.SAVE_CONFIG:
            return saveConfig(state, action);
        case actionTypes.SET_IS_MOBILE:
            return setIsMobile(state, action);
        case actionTypes.SET_IS_MENU_MOBILE_SELECTED:
            return setIsMenuMobileSelected(state, action);
        default:
            return state;
    }
}

export default reducer;

/* SAVE CONFIG */
const saveConfig = (state, action) => {
    return updateObject(state, {
        config: action.config
    })
}

/* SET MOBILE VIEW */
const setIsMobile = (state, action) => {
    return updateObject(state, {
        isMobile: action.isMobile
    })
}

/* SET MENU MOBILE VIEW */
const setIsMenuMobileSelected = (state, action) => {
    return updateObject(state, {
        isMenuMobileSelected: action.isMenuMobileSelected
    })
}